module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('step', {
    attrs: {
      "navItems": _vm.navItems,
      "canNext": _vm.canNext,
      "index": 1,
      "step": _vm.step
    },
    on: {
      "step": _vm.updateStep,
      "back": function () {
        this$1.$router.push('/group-mgr')
      }
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('add_student')))])]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 offset-sm-4"
  }, [_c('form', {
    staticClass: "form-custom pt-0 bg-white"
  }, [_c('label', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('username')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.userName),
      expression: "student.userName"
    }],
    staticClass: "form-control mt-3 rounded",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('please_enter_account_required'),
      "required": ""
    },
    domProps: {
      "value": (_vm.student.userName)
    },
    on: {
      "change": _vm.checkNecessary,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "userName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "callout"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('plese_enter_account_rules'))), _c('br'), _vm._v(" " + _vm._s(_vm.$t('sample_account')) + "\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.password),
      expression: "student.password"
    }],
    staticClass: "form-control mt-3 rounded",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('please_enter_password_required'),
      "required": ""
    },
    domProps: {
      "value": (_vm.student.password)
    },
    on: {
      "change": _vm.checkNecessary,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "callout"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('please_enter_password_rule')) + "\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.realName),
      expression: "student.realName"
    }],
    staticClass: "form-control mt-3 rounded",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('please_enter_name_required'),
      "required": ""
    },
    domProps: {
      "value": (_vm.student.realName)
    },
    on: {
      "change": _vm.checkNecessary,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "realName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "callout"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('please_enter_students_full_name')) + "\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('student_id')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.student.studentNo),
      expression: "student.studentNo"
    }],
    staticClass: "form-control mt-3 rounded",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('please_enter_student_ID'),
      "required": ""
    },
    domProps: {
      "value": (_vm.student.studentNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.student, "studentNo", $event.target.value)
      }
    }
  })])])])])], 2), _vm._v(" "), _c('step', {
    attrs: {
      "navItems": _vm.navItems,
      "index": 2,
      "step": _vm.step
    },
    on: {
      "step": _vm.updateStep,
      "finish": function () {
        this$1.$router.push('/group-mgr')
      }
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('complete')))])]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', {
    staticClass: "col-8 offset-2"
  }, [_c('ul', {
    staticClass: "list-group list-group-flush"
  }, [_c('li', {
    staticClass: "list-group-item border text-left mb-3 rounded",
    staticStyle: {
      "line-height": "150%"
    }
  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.student.realName)), _c('br'), _vm._v(_vm._s(_vm.$t('established_date')) + "：" + _vm._s(_vm.now) + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  })])])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-88c89db8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teacher/TeachingGroupAddStudent.vue
// module id = 801
// module chunks = 3